import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

import ModalHeader from "../../Components/Header/ModalHeader";
import "../Master/MasterFormStyles.scss";
import { MultiSelect } from "primereact/multiselect";
import { useTranslation } from "react-i18next";
import {
  updateSubcentersonAnmDetails,
  approveSubcentersonAnmDetails,
  rejectSubcentersonAnmDetails,
  fetchSubcenterList,
  fetchANMDetails,
} from "../../Store/ANMDetails/ANMDetailsActions";
import { useDispatch, useSelector } from "react-redux";
import { useLanguage } from "../ChangeLanguage/LanguageProvider";
import { getSubcenterList } from "../../Store/ANMDetails/ANMDetailsSelectors";

const ANMUpdateform = ({ mode, selectedItems, visible, setVisible,type }) => {
  const subcenters = useSelector(getSubcenterList);
  const dispatch = useDispatch();
  const [, setTitle] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const status =
    selectedItems.length > 0 ? selectedItems[0]?.status?.toString() : "";
  const userRole = sessionStorage.getItem("userRole");
  const selectedID = selectedItems.map((item) => item.ashaanmid)[0];
  const { selectedLanguageId } = useLanguage();
  const checkPhc = () =>{
    if(type == 'ANM'){
      return "AnmDetailsUpdatePhc"
    }else if (type == 'AF') {
    return "AfDetailsUpdatePhc"
    }
  }
  var { t } = useTranslation(`${checkPhc()}`);
  useEffect(() => {
    if (mode === "Update") {
      const assignedOptions =
        subcenters && subcenters.Assigned ? subcenters.Assigned : [];
      const approvedSelectedOptions = selectedItems.filter(
        ({ status }) => status === "Approved"
      );
      const newSelectedOptions = approvedSelectedOptions
        ? assignedOptions.map((option) => option.subcenterid)
        : [];
      setSelectedOptions(newSelectedOptions);
    }
  }, [subcenters, selectedItems, mode]);
  const assigned = subcenters && subcenters.Assigned ? subcenters.Assigned : [];

  const unassigned =
    subcenters && subcenters.Unassigned ? subcenters.Unassigned : [];
  useEffect(() => {
    dispatch(fetchSubcenterList(selectedLanguageId, selectedID));
  }, [dispatch, selectedID, selectedLanguageId]);

  const options = assigned.concat(unassigned).map((option) => ({
    label: option.subcentername,
    value: option.subcenterid,
  }));

  const handleOptionChange = (e) => {
    setSelectedOptions(e.value);
  };
  const handleApproveAnm = () => {
    dispatch(approveSubcentersonAnmDetails(selectedID, selectedOptions));
    dispatch(fetchANMDetails(selectedLanguageId));
    window.location.reload();
  };

  const handleUpdateAnm = () => {
    dispatch(updateSubcentersonAnmDetails(selectedID, selectedOptions));
    dispatch(fetchANMDetails(selectedLanguageId));
    window.location.reload();
  };
  const handleClearUpdateAnm = () => {
    selectedOptions([]);
    setSelectedOptions([]);
  };
  const handleRejectUpdateAnm = () => {
    dispatch(rejectSubcentersonAnmDetails(selectedID));
    dispatch(fetchANMDetails(selectedLanguageId));
  };

  return (
    <Dialog
      className="cockpit-dialog"
      visible={visible}
      modal={true}
      position={"center"}
      draggable={false}
      resizable={false}
      onHide={() => setVisible(false)}
      closeOnEscape={false}
      header={
        <ModalHeader
          onClose={() => setVisible(false)}
          backText={t("BacktoANMDetails")}
        />
      }
    >
      <div className="pl-3 pt-1 pr-3">
        <div className="flex flex-wrap align-items-center justify-content-between">
          <div className="form_title" data-testid="header-iecmoduleform">
            {t("UpdateANMDetails")}
          </div>
        </div>
        <div className="master-form">
          <div className="col-12 md:col-6 lg:col-3">
            {t("Registrationrequestedon")} : 12/02/2023
          </div>
          <div className="flex grid p-3">
            <div className="col-12 md:col-6 lg:col-3">
              <label htmlFor="title" className="input-label">
                <span className="required-field">*</span>
                {t("FirstName")}
              </label>
              <InputText
                id="title"
                value={
                  selectedItems.length > 0
                    ? selectedItems.map((item) => item.firstname)
                    : ""
                }
                disabled
                className="input-style"
                data-testid="title-input-test"
              />
            </div>

            <div className="col-12 md:col-6 lg:col-3">
              <label htmlFor="title" className="input-label">
                <span className="required-field">*</span>
                {t("LastName")}
              </label>
              <InputText
                id="title"
                value={
                  selectedItems.length > 0
                    ? selectedItems.map((item) => item.lastname)
                    : ""
                }
                disabled
                onChange={(e) => setTitle(e.target.value)}
                className="input-style"
                data-testid="title-input-test-lastname"
              />
            </div>

            <div className="col-12 md:col-6 lg:col-3">
              <label htmlFor="title" className="input-label">
                <span className="required-field">*</span>
                {t("DOB")} :
              </label>
              <InputText
                id="title"
                mobilenumber
                value={selectedItems.length > 0 ? selectedItems[0].dob : ""}
                disabled
                onChange={(e) => setTitle(e.target.value)}
                className="input-style"
                data-testid="title-input-tests-dob"
              />
            </div>

            <div className="col-12 md:col-6 lg:col-3">
              <label htmlFor="title" className="input-label">
                <span className="required-field">*</span>
                {t("ContactNo")}
              </label>
              <InputText
                id="title"
                value={
                  selectedItems.length > 0
                    ? selectedItems.map((item) => item.mobilenumber).join(", ") // Convert array to string
                    : ""
                }
                disabled
                onChange={(e) => setTitle(e.target.value)}
                className="input-style"
                data-testid="title-input-test-mobilenumber"
              />
            </div>
            {userRole === 'UPHC MO' ? (
              <></>
            ):(
            <div className="col-12 md:col-6 lg:col-3">
              <label htmlFor="title" className="input-label">
                <span className="required-field">*</span>
                {t("AssignSubcenters")}
              </label>
              <div className="card flex">
                <MultiSelect
                  value={selectedOptions}
                  options={options}
                  onChange={handleOptionChange}
                  optionLabel="label"
                  placeholder="Select Subcenters"
                  data-testid="subcenter-select"
                />
              </div>
            </div>
            )} 
          </div>

          {status === "Approved" || status === "Rejected" ? (
            <div className="flex gap-3 mastersFormBtnGroup justify-content-center m-2">
              <Button
                className="formBtn-clear"
                label={t("Clear")}
                data-testid="clear-button"
                onClick={handleClearUpdateAnm}
              />
              <Button
                className="formBtn-primary"
                label={t("Update")}
                data-testid="update-button"
                style={{ width: "253px", height: "40px", fontWeight: 600 }}
                onClick={handleUpdateAnm}
              />
            </div>
          ) : (
            <div className="flex gap-3 mastersFormBtnGroup justify-content-center m-2">
              <Button
                className="formBtn-clear"
                label={t("Clear")}
                data-testid="clear-button"
              />
              <Button
                className="formBtn"
                label={t("RejectRegistration")}
                data-testid="add-button"
                onClick={handleRejectUpdateAnm}
                style={{
                  borderColor: "red",
                  color: "red",
                  backgroundColor: "white",
                  width: "253px",
                  height: "40px",
                }}
              />
              <Button
                className="formBtn-primary"
                label={t("ApproveRegistration")}
                data-testid="add-button"
                style={{ width: "253px", height: "40px", fontWeight: 600 }}
                onClick={handleApproveAnm}
              />
            </div>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default ANMUpdateform;
